import styled from 'styled-components';
import { Container } from '../../../../common/Styles';

export const CustomerStoriesContainer = styled(Container)(
	({ theme: { down, breakpoints } }) => `
		padding: 50px 0;
		margin-bottom: 50px !important;
		${down(breakpoints.md)} {
			margin-bottom: 0 !important;
		}
	`
);

export const SliderOuterWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
		margin-top: 56px;
		.slick-track {
			display: flex;
		}
		${down(breakpoints.md)} {
			margin-top: 28px;
			padding-left: 16px;
		}
	`
);

export const CustomerStoriesInnerWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
		padding-right: 55px;
		min-height: 470px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		${down(breakpoints.md)} {
			min-height: 350px;
			padding-right: 25px;
			width: 270px !important;
		}
		img{
			border-radius: 10px;
		}
	`
);

export const CustomerStoriesTextWrap = styled.p(
	({ theme: { down, breakpoints } }) => `
		font-size: 22px;
		padding: 0 0 24px 0;
		font-style: italic;
		color: #3B385E;
		${down(breakpoints.md)} {
			font-size: 16px;
			padding: 0 0 16px 0;
		}
	`
);
